<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
/*// =============================================================================
Start Custom mega menu
// =============================================================================*/
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.site-nav-title').forEach(function(tab) {
    tab.addEventListener('click', function() {
      const activeTab = this.getAttribute('data-tab');

      document.querySelectorAll('.tab-content').forEach(function(content) {
        content.style.display = 'none';
      });

      const selectedTab = document.querySelector(`#tab-${activeTab}`);
      if (selectedTab) {
        selectedTab.style.display = 'block';
      }

      document.querySelectorAll('.site-nav-title').forEach(function(tab) {
        tab.classList.remove('active');
      });
      this.classList.add('active');
    });
  });
});

$('.site-nav-title.active').each(function() {
  $(this).closest('.site-nav-list').addClass('active-parent');
});
/*// =============================================================================
End Custom mega menu
// =============================================================================*/